import { render } from "./SliderHome.vue?vue&type=template&id=2ccc199e"
import script from "./SliderHome.vue?vue&type=script&lang=js"
export * from "./SliderHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__